import DataProvider from "./data-provider";
import PaletteProvider from "./palette-provider";

export { DataProvider, PaletteProvider };
